import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorLoggerService, HttpError } from '@ideals/services/error-logger';

export function errorsLoggerInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const errorLoggerService = inject(ErrorLoggerService);

  return next(request).pipe(
    catchError((response: HttpErrorResponse) => {
      const error: HttpError = {
        message: response.message,
        error: response.error instanceof Event ? {} : response.error as unknown,
        headers: response.headers,
        method: request.method as HttpError['method'],
        statusCode: response.status,
        statusText: response.statusText,
        url: response.url,
      };

      errorLoggerService.handleHttpError(error);

      return throwError(() => response);
    })
  );
}
